module.exports = __webpack_public_path__ + "img/part8@2x.123ba72d.png";